import { Component, Input } from "@angular/core";

@Component({
    selector: 'user-info',
    template: `
    <div class="d-flex align-items-center">
      <img
              class="rounded-circle me-1"
              [src]="user?.imageUrl |secure |async"
              default-avatar
              height="32"
              width="32"
              alt="datatable-avatar"
      />
      <div class="cell-line-height">

        <text-truncate-popover
                class="font-weight-bold d-block text-nowrap font-small-5"
                [text]="user?.name"
                [maxLength]="maxLength"
                popoverTitle="User Name">
        </text-truncate-popover>

        <text-truncate-popover
                class="text-muted font-small-2"
                [text]="user?.email"
                [maxLength]="maxLength"
                popoverTitle="User Email">
        </text-truncate-popover>
        
        <i *ngIf="user?.emailConfirmed === true" class="ri-mail-check-fill align-bottom ms-1 text-success"></i>
        <i *ngIf="user?.emailConfirmed === false" class="ri-mail-close-fill align-bottom ms-1 text-danger"></i>

      </div>
    </div>
  `,
    standalone: false
})
export class UserInfoComponent {

  @Input('user') user: IUserInfo | undefined;
  @Input('maxLength') maxLength: number = 60;

}

export interface IUserInfo {
  name: string;
  email: string;
  emailConfirmed?: boolean;
  imageUrl: string;
}
